module.exports = __webpack_public_path__ + "img/woman-filled-autonomous.b1bfda34.svg";